import React from 'react'
import './withme.css'


function sendEmail(){
alert("Message send Sucessfully")
}

export const Joinwithme = () => {
  return (
    <div className='withme' id='withme'>
        <form onSubmit={sendEmail}>
            <h3>Join With <span className='spantag'>Me</span></h3>
            <input type='text' id='name' placeholder='Enter your name' required/>
            <input type='email' id='email' placeholder='Enter your Email' required/>
            <input type='text' id='number' placeholder='Enter your Mobile Number' required/>
            <input id ="message" placeholder="How can we help you?" rows="4" className='textarea' />
            <button type='submit'>Send</button>
        </form>
    </div>
  )
}
